import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBar,
} from "@angular/material/snack-bar";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { environment } from "src/environments/environment";
@Injectable()
export class GeneralService {
  getImgSrc(guid) {
    return this.base_url + "/images/" + guid;
  }
  constructor(private http: HttpClient, public snackBar: MatSnackBar) {
    if (this.cuurentUser == "SNCT") {
      this.getArtxcel();
    }
    if (!localStorage.getItem("login")) {
      localStorage.setItem("login", "false");
    } else {
      if (localStorage.getItem("login") == "false") this.userLogin = false;
      else this.userLogin = true;
    }
  }
  loginUniges(ds) {
    return this.http.post(this.api + "users/login", ds);
  }
  base_url = environment.base_url;
  userLogin;
  public api = this.base_url + "api/";
  useDataBaseToSaveImage = environment.useDataBaseToSaveImage;
  cuurentUser = environment.current_user;
  url = "recherche/tbdata?tablere=";
  //http://197.14.49.3:86/api/recherche/tbdata?tablere=ecMarque
  //liste des marques
  urlListeMarques = this.url + "ecMarque";

  //https://backend-legacy.pmc.tn/api/recherche/tbdata?tablere=ecArtCarValList&param=0
  urllisteValeurCaracteristique = this.url + "ecArtCarValList&param=";

  //http://197.14.49.3:86/api/ds/formdata?code=ecArtCarValList
  //ds ValeurCaracteristiqu
  urlValeurCaracteristique = "ds/formdata?code=ecArtCarValList";
  getDS(formdata, param?) {
    if (!param) {
      return this.http.get(this.api + "ds/formdata?code=" + formdata);
    }
    return this.http.get(
      this.api + "ds/formdata?code=" + formdata + "&val=" + param
    );
  }
  artExcel;
  getArtxcel() {
    this.http.get(this.api + this.url + "artxls").subscribe((res: any) => {
      this.artExcel = res;
    });
  }

  //http://197.14.49.3:86/api/ds/formdata?code=ecMarque
  //ds Marque Article
  urlMarqueArticle = "ds/formdata?code=ecMarque";
  dsListCat = "ds/formdata?code=ecArtCatArticle";
  urlIdArtComp = "recherche/tbdata?tablere=ecArtComptot&param=";
  //http://197.14.49.3:86/api/ds/formdata?code=ecArtComp
  //ds produit complaimentaire et similaire
  urlProduitComp = "ds/formdata?code=ecArtComp";

  //http://197.14.49.3:86/api/ds/formdata?code=ecArtComp
  //ds produit complaimentaire et similaire
  urlListeProduitComp = this.url + "ecArtComp&param=";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecGroup
  //ds Group
  urlGroup = "ds/formdata?code=ecGroup";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecGroup
  //liste categorie
  urlListeGroup = this.url + "ecGroup";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecGroupMenu
  //liste
  urlListeGroupMenu = this.url + "ecGroupMenu";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecGroupArt
  urlListeGroupArt = this.url + "ecGroupArt";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecGroupArt
  // ds GroupArt
  urlGroupArt = "ds/formdata?code=ecGroupArt";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecartcarval&param=08AR0001_X11
  // liste caracteristique article
  urlListeCaracteristiqueArticle = this.url + "ecartcarval&param=";

  //ds caracteristique article
  urlCaracteristiqueArticle = "ds/formdata?code=ecartcarval";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecartcat&val=1
  //ds categorie
  urlcategorie = "ds/formdata?code=ecartcat";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecartcarmod&val=1
  //ds carectiristique model
  urlcaracteristiqueModel = "ds/formdata?code=ecartcarmod";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecGroupMenu
  //ds carectiristique model
  urlGroupMenu = "ds/formdata?code=ecGroupMenu";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecartcarmod
  //liste carectiristique model
  urlListeModel = this.url + "ecartcarmod";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecartcar&val=1
  //ds carectiristique
  urlCarectiristique = "ds/formdata?code=ecartcar";

  //http://unilog.ddns.net:86/api/ds/formdata?code=ecartcarval2
  //ds carectiristique pour un code article
  urlCarectiristique2 = "ds/formdata?code=ecartcarval2";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ecartcar
  //liste carectiristique
  urlListeCaracteristique = this.url + "ecartcar";

  //https://backend-legacy.pmc.tn/api/recherche/tbdata?tablere=ecartcat
  urlListeCategorie = this.url + "ecartcat";
  // ds file
  urlAvtDoc = "ds/ajout?dstables=files";

  urlFiles = "ds/formdata?code=avtFiles";
  listImageByClass = "recherche/tbdata?tablere=apiArtClass&param=";
  urlListCat = "recherche/tbdata?tablere=ecArtCatArticle&param=";
  //recherche document par code: retourne un document coder en base46
  // http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesContent&param=213
  urlDoc = this.url + "avtFilesContent&param=";
  //ex : https://necom.pmc.tn/api/recherche/tbdata?tablere=avtDoc&param=cmd,20000101,20190101
  urlListeDoc = this.url + "avtDoc&param=";

  //liste document par group et type
  urlListeFilesR2 = this.url + "avtFilesR2&param=";

  //liste document pour un collaboaeteur
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFiles&param=10,collaborateur
  urlListeDocColl = this.url + "avtFiles&param=";

  //recherche document par code: retourne un document coder en base46
  // http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesC&param=0041,collaborateur,cv
  urlFindDoc = this.url + "avtFilesC&param=";

  //http://197.14.49.3:86/api/ds/formdata?code=ecart&val=01
  // ds article
  urlArticle = "ds/formdata?code=ecart";

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=article
  //liste article
  urlListeArticles = this.url + "article";

  //http://197.14.49.3:86/api/users/loginTier?id=c0034&pw=123
  urlConnectionClient = "users/loginTier?id=";

  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  userConnecter: string = "a";
  showMenu = true;

  dsLanguage;
  disabled: boolean = false;
  listeLanges = [];
  dsFile;
  fontFamily = [
    {
      fontFamily: "Abadi MT Condensed Light",
      APPEARANCE: "Abadi MT Condensed Light",
    },
    {
      fontFamily: "Aharoni",
      APPEARANCE: "Aharoni",
    },
    {
      fontFamily: "Aharoni Bold",
      APPEARANCE: "Aharoni Bold",
    },
    {
      fontFamily: "Aldhabi",
      APPEARANCE: "Aldhabi",
    },
    {
      fontFamily: "AlternateGothic2 BT",
      APPEARANCE: "AlternateGothic2 BT",
    },
    {
      fontFamily: "Andale Mono",
      APPEARANCE: "Andale Mono",
    },
    {
      fontFamily: "Andalus",
      APPEARANCE: "Andalus",
    },
    {
      fontFamily: "Angsana New",
      APPEARANCE: "Angsana New",
    },
    {
      fontFamily: "AngsanaUPC",
      APPEARANCE: "AngsanaUPC",
    },
    {
      fontFamily: "Aparajita",
      APPEARANCE: "Aparajita",
    },
    {
      fontFamily: "Apple Chancery",
      APPEARANCE: "Apple Chancery",
    },
    {
      fontFamily: "Arabic Typesetting",
      APPEARANCE: "Arabic Typesetting",
    },
    {
      fontFamily: "Arial",
      APPEARANCE: "Arial",
    },
    {
      fontFamily: "Arial Black",
      APPEARANCE: "Arial Black",
    },
    {
      fontFamily: "Arial narrow",
      APPEARANCE: "Arial narrow",
    },
    {
      fontFamily: "Arial Nova",
      APPEARANCE: "Arial Nova",
    },
    {
      fontFamily: "Arial Rounded MT Bold",
      APPEARANCE: "Arial Rounded MT Bold",
    },
    {
      fontFamily: "Arnoldboecklin",
      APPEARANCE: "Arnoldboecklin",
    },
    {
      fontFamily: "Avanta Garde",
      APPEARANCE: "Avanta Garde",
    },
    {
      fontFamily: "Bahnschrift",
      APPEARANCE: "Bahnschrift",
    },
    {
      fontFamily: "Bahnschrift Light",
      APPEARANCE: "Bahnschrift Light",
    },
    {
      fontFamily: "Bahnschrift SemiBold",
      APPEARANCE: "Bahnschrift SemiBold",
    },
    {
      fontFamily: "Bahnschrift SemiLight",
      APPEARANCE: "Bahnschrift SemiLight",
    },
    {
      fontFamily: "Baskerville",
      APPEARANCE: "Baskerville",
    },
    {
      fontFamily: "Batang",
      APPEARANCE: "Batang",
    },
    {
      fontFamily: "BatangChe",
      APPEARANCE: "BatangChe",
    },
    {
      fontFamily: "Big Caslon",
      APPEARANCE: "Big Caslon",
    },
    {
      fontFamily: "BIZ UDGothic",
      APPEARANCE: "BIZ UDGothic",
    },
    {
      fontFamily: "BIZ UDMincho Medium",
      APPEARANCE: "BIZ UDMincho Medium",
    },
    {
      fontFamily: "Blippo",
      APPEARANCE: "Blippo",
    },
    {
      fontFamily: "Bodoni MT",
      APPEARANCE: "Bodoni MT",
    },
    {
      fontFamily: "Book Antiqua",
      APPEARANCE: "Book Antiqua",
    },
    {
      fontFamily: "Book Antiqua",
      APPEARANCE: "Book Antiqua",
    },
    {
      fontFamily: "Bookman",
      APPEARANCE: "Bookman",
    },
    {
      fontFamily: "Bradley Hand",
      APPEARANCE: "Bradley Hand",
    },
    {
      fontFamily: "Browallia New",
      APPEARANCE: "Browallia New",
    },
    {
      fontFamily: "BrowalliaUPC",
      APPEARANCE: "BrowalliaUPC",
    },
    {
      fontFamily: "Brush Script MT",
      APPEARANCE: "Brush Script MT",
    },
    {
      fontFamily: "Brush Script Std",
      APPEARANCE: "Brush Script Std",
    },
    {
      fontFamily: "Brushstroke",
      APPEARANCE: "Brushstroke",
    },
    {
      fontFamily: "Calibri",
      APPEARANCE: "Calibri",
    },
    {
      fontFamily: "Calibri Light",
      APPEARANCE: "Calibri Light",
    },
    {
      fontFamily: "Calisto MT",
      APPEARANCE: "Calisto MT",
    },
    {
      fontFamily: "Cambodian",
      APPEARANCE: "Cambodian",
    },
    {
      fontFamily: "Cambria",
      APPEARANCE: "Cambria",
    },
    {
      fontFamily: "Cambria Math",
      APPEARANCE: "Cambria Math",
    },
    {
      fontFamily: "Candara",
      APPEARANCE: "Candara",
    },
    {
      fontFamily: "Century Gothic",
      APPEARANCE: "Century Gothic",
    },
    {
      fontFamily: "Chalkduster",
      APPEARANCE: "Chalkduster",
    },
    {
      fontFamily: "Cherokee",
      APPEARANCE: "Cherokee",
    },
    {
      fontFamily: "Comic Sans",
      APPEARANCE: "Comic Sans",
    },
    {
      fontFamily: "Comic Sans MS",
      APPEARANCE: "Comic Sans MS",
    },
    {
      fontFamily: "Consolas",
      APPEARANCE: "Consolas",
    },
    {
      fontFamily: "Constantia",
      APPEARANCE: "Constantia",
    },
    {
      fontFamily: "Copperplate",
      APPEARANCE: "Copperplate",
    },
    {
      fontFamily: "Copperplate Gothic Light",
      APPEARANCE: "Copperplate Gothic Light",
    },
    {
      fontFamily: "Copperplate Gothic Bold",
      APPEARANCE: "Copperplate Gothic Bold",
    },
    {
      fontFamily: "Corbel",
      APPEARANCE: "Corbel",
    },
    {
      fontFamily: "Cordia New",
      APPEARANCE: "Cordia New",
    },
    {
      fontFamily: "CordiaUPC",
      APPEARANCE: "CordiaUPC",
    },
    {
      fontFamily: "Coronetscript",
      APPEARANCE: "Coronetscript",
    },
    {
      fontFamily: "Courier",
      APPEARANCE: "Courier",
    },
    {
      fontFamily: "Courier New",
      APPEARANCE: "Courier New",
    },
    {
      fontFamily: "DaunPenh",
      APPEARANCE: "DaunPenh",
    },
    {
      fontFamily: "David",
      APPEARANCE: "David",
    },
    {
      fontFamily: "DengXian",
      APPEARANCE: "DengXian",
    },
    {
      fontFamily: "DFKai-SB",
      APPEARANCE: "DFKai-SB",
    },
    {
      fontFamily: "Didot",
      APPEARANCE: "Didot",
    },
    {
      fontFamily: "DilleniaUPC",
      APPEARANCE: "DilleniaUPC",
    },
    {
      fontFamily: "DokChampa",
      APPEARANCE: "DokChampa",
    },
    {
      fontFamily: "Dotum",
      APPEARANCE: "Dotum",
    },
    {
      fontFamily: "DotumChe",
      APPEARANCE: "DotumChe",
    },
    {
      fontFamily: "Ebrima",
      APPEARANCE: "Ebrima",
    },
    {
      fontFamily: "Estrangelo Edessa",
      APPEARANCE: "Estrangelo Edessa",
    },
    {
      fontFamily: "EucrosiaUPC",
      APPEARANCE: "EucrosiaUPC",
    },
    {
      fontFamily: "Euphemia",
      APPEARANCE: "Euphemia",
    },
    {
      fontFamily: "FangSong",
      APPEARANCE: "FangSong",
    },
    {
      fontFamily: "Florence",
      APPEARANCE: "Florence",
    },
    {
      fontFamily: "Franklin Gothic Medium",
      APPEARANCE: "Franklin Gothic Medium",
    },
    {
      fontFamily: "FrankRuehl",
      APPEARANCE: "FrankRuehl",
    },
    {
      fontFamily: "FreesiaUPC",
      APPEARANCE: "FreesiaUPC",
    },
    {
      fontFamily: "Futara",
      APPEARANCE: "Futara",
    },
    {
      fontFamily: "Gabriola",
      APPEARANCE: "Gabriola",
    },
    {
      fontFamily: "Gadugi",
      APPEARANCE: "Gadugi",
    },
    {
      fontFamily: "Garamond",
      APPEARANCE: "Garamond",
    },
    {
      fontFamily: "Gautami",
      APPEARANCE: "Gautami",
    },
    {
      fontFamily: "Geneva",
      APPEARANCE: "Geneva",
    },
    {
      fontFamily: "Georgia",
      APPEARANCE: "Georgia",
    },
    {
      fontFamily: "Georgia Pro",
      APPEARANCE: "Georgia Pro",
    },
    {
      fontFamily: "Gill Sans",
      APPEARANCE: "Gill Sans",
    },
    {
      fontFamily: "Gill Sans Nova",
      APPEARANCE: "Gill Sans Nova",
    },
    {
      fontFamily: "Gisha",
      APPEARANCE: "Gisha",
    },
    {
      fontFamily: "Goudy Old Style",
      APPEARANCE: "Goudy Old Style",
    },
    {
      fontFamily: "Gulim",
      APPEARANCE: "Gulim",
    },
    {
      fontFamily: "GulimChe",
      APPEARANCE: "GulimChe",
    },
    {
      fontFamily: "Gungsuh",
      APPEARANCE: "Gungsuh",
    },
    {
      fontFamily: "GungsuhChe",
      APPEARANCE: "GungsuhChe",
    },
    {
      fontFamily: "Hebrew",
      APPEARANCE: "Hebrew",
    },
    {
      fontFamily: "Hoefler Text",
      APPEARANCE: "Hoefler Text",
    },
    {
      fontFamily: "HoloLens MDL2 Assets",
      APPEARANCE: "HoloLens MDL2 Assets",
    },
    {
      fontFamily: "Impact",
      APPEARANCE: "Impact",
    },
    {
      fontFamily: "Ink Free",
      APPEARANCE: "Ink Free",
    },
    {
      fontFamily: "IrisUPC",
      APPEARANCE: "IrisUPC",
    },
    {
      fontFamily: "Iskoola Pota",
      APPEARANCE: "Iskoola Pota",
    },
    {
      fontFamily: "Japanese",
      APPEARANCE: "Japanese",
    },
    {
      fontFamily: "JasmineUPC",
      APPEARANCE: "JasmineUPC",
    },
    {
      fontFamily: "Javanese Text",
      APPEARANCE: "Javanese Text",
    },
    {
      fontFamily: "Jazz LET",
      APPEARANCE: "Jazz LET",
    },
    {
      fontFamily: "KaiTi",
      APPEARANCE: "KaiTi",
    },
    {
      fontFamily: "Kalinga",
      APPEARANCE: "Kalinga",
    },
    {
      fontFamily: "Kartika",
      APPEARANCE: "Kartika",
    },
    {
      fontFamily: "Khmer UI",
      APPEARANCE: "Khmer UI",
    },
    {
      fontFamily: "KodchiangUPC",
      APPEARANCE: "KodchiangUPC",
    },
    {
      fontFamily: "Kokila",
      APPEARANCE: "Kokila",
    },
    {
      fontFamily: "Korean",
      APPEARANCE: "Korean",
    },
    {
      fontFamily: "Lao",
      APPEARANCE: "Lao",
    },
    {
      fontFamily: "Lao UI",
      APPEARANCE: "Lao UI",
    },
    {
      fontFamily: "Latha",
      APPEARANCE: "Latha",
    },
    {
      fontFamily: "Leelawadee",
      APPEARANCE: "Leelawadee",
    },
    {
      fontFamily: "Leelawadee UI",
      APPEARANCE: "Leelawadee UI",
    },
    {
      fontFamily: "Leelawadee UI Semilight",
      APPEARANCE: "Leelawadee UI Semilight",
    },
    {
      fontFamily: "Levenim MT",
      APPEARANCE: "Levenim MT",
    },
    {
      fontFamily: "LilyUPC",
      APPEARANCE: "LilyUPC",
    },
    {
      fontFamily: "Lucida Bright",
      APPEARANCE: "Lucida Bright",
    },
    {
      fontFamily: "Lucida Console",
      APPEARANCE: "Lucida Console",
    },
    {
      fontFamily: "Lucida Handwriting",
      APPEARANCE: "Lucida Handwriting",
    },
    {
      fontFamily: "Lucida Sans",
      APPEARANCE: "Lucida Sans",
    },
    {
      fontFamily: "Lucida Sans Typewriter",
      APPEARANCE: "Lucida Sans Typewriter",
    },
    {
      fontFamily: "Lucida Sans Unicode",
      APPEARANCE: "Lucida Sans Unicode",
    },
    {
      fontFamily: "Lucidatypewriter",
      APPEARANCE: "Lucidatypewriter",
    },
    {
      fontFamily: "Luminari",
      APPEARANCE: "Luminari",
    },
    {
      fontFamily: "Malgun Gothic",
      APPEARANCE: "Malgun Gothic",
    },
    {
      fontFamily: "Malgun Gothic Semilight",
      APPEARANCE: "Malgun Gothic Semilight",
    },
    {
      fontFamily: "Mangal",
      APPEARANCE: "Mangal",
    },
    {
      fontFamily: "Marker Felt",
      APPEARANCE: "Marker Felt",
    },
    {
      fontFamily: "Marlett",
      APPEARANCE: "Marlett",
    },
    {
      fontFamily: "Meiryo",
      APPEARANCE: "Meiryo",
    },
    {
      fontFamily: "Meiryo UI",
      APPEARANCE: "Meiryo UI",
    },
    {
      fontFamily: "Microsoft Himalaya",
      APPEARANCE: "Microsoft Himalaya",
    },
    {
      fontFamily: "Microsoft JhengHei",
      APPEARANCE: "Microsoft JhengHei",
    },
    {
      fontFamily: "Microsoft JhengHei UI",
      APPEARANCE: "Microsoft JhengHei UI",
    },
    {
      fontFamily: "Microsoft New Tai Lue",
      APPEARANCE: "Microsoft New Tai Lue",
    },
    {
      fontFamily: "Microsoft PhagsPa",
      APPEARANCE: "Microsoft PhagsPa",
    },
    {
      fontFamily: "Microsoft Sans Serif",
      APPEARANCE: "Microsoft Sans Serif",
    },
    {
      fontFamily: "Microsoft Tai Le",
      APPEARANCE: "Microsoft Tai Le",
    },
    {
      fontFamily: "Microsoft Uighur",
      APPEARANCE: "Microsoft Uighur",
    },
    {
      fontFamily: "Microsoft YaHei",
      APPEARANCE: "Microsoft YaHei",
    },
    {
      fontFamily: "Microsoft YaHei UI",
      APPEARANCE: "Microsoft YaHei UI",
    },
    {
      fontFamily: "Microsoft Yi Baiti",
      APPEARANCE: "Microsoft Yi Baiti",
    },
    {
      fontFamily: "MingLiU",
      APPEARANCE: "MingLiU",
    },
    {
      fontFamily: "MingLiU_HKSCS",
      APPEARANCE: "MingLiU_HKSCS",
    },
    {
      fontFamily: "MingLiU_HKSCS-ExtB",
      APPEARANCE: "MingLiU_HKSCS-ExtB",
    },
    {
      fontFamily: "MingLiU-ExtB",
      APPEARANCE: "MingLiU-ExtB",
    },
    {
      fontFamily: "Miriam",
      APPEARANCE: "Miriam",
    },
    {
      fontFamily: "Monaco",
      APPEARANCE: "Monaco",
    },
    {
      fontFamily: "Mongolian Baiti",
      APPEARANCE: "Mongolian Baiti",
    },
    {
      fontFamily: "MoolBoran",
      APPEARANCE: "MoolBoran",
    },
    {
      fontFamily: "MS Gothic",
      APPEARANCE: "MS Gothic",
    },
    {
      fontFamily: "MS Mincho",
      APPEARANCE: "MS Mincho",
    },
    {
      fontFamily: "MS PGothic",
      APPEARANCE: "MS PGothic",
    },
    {
      fontFamily: "MS PMincho",
      APPEARANCE: "MS PMincho",
    },
    {
      fontFamily: "MS UI Gothic",
      APPEARANCE: "MS UI Gothic",
    },
    {
      fontFamily: "MV Boli",
      APPEARANCE: "MV Boli",
    },
    {
      fontFamily: "Myanmar Text",
      APPEARANCE: "Myanmar Text",
    },
    {
      fontFamily: "Narkisim",
      APPEARANCE: "Narkisim",
    },
    {
      fontFamily: "Neue Haas Grotesk Text Pro",
      APPEARANCE: "Neue Haas Grotesk Text Pro",
    },
    {
      fontFamily: "New Century Schoolbook",
      APPEARANCE: "New Century Schoolbook",
    },
    {
      fontFamily: "News Gothic MT",
      APPEARANCE: "News Gothic MT",
    },
    {
      fontFamily: "Nirmala UI",
      APPEARANCE: "Nirmala UI",
    },
    {
      fontFamily: "No automatic language associations",
      APPEARANCE: "No automatic language associations",
    },
    {
      fontFamily: "Noto",
      APPEARANCE: "Noto",
    },
    {
      fontFamily: "NSimSun",
      APPEARANCE: "NSimSun",
    },
    {
      fontFamily: "Nyala",
      APPEARANCE: "Nyala",
    },
    {
      fontFamily: "Oldtown",
      APPEARANCE: "Oldtown",
    },
    {
      fontFamily: "Optima",
      APPEARANCE: "Optima",
    },
    {
      fontFamily: "Palatino",
      APPEARANCE: "Palatino",
    },
    {
      fontFamily: "Palatino Linotype",
      APPEARANCE: "Palatino Linotype",
    },
    {
      fontFamily: "papyrus",
      APPEARANCE: "papyrus",
    },
    {
      fontFamily: "Parkavenue",
      APPEARANCE: "Parkavenue",
    },
    {
      fontFamily: "Perpetua",
      APPEARANCE: "Perpetua",
    },
    {
      fontFamily: "Plantagenet Cherokee",
      APPEARANCE: "Plantagenet Cherokee",
    },
    {
      fontFamily: "PMingLiU",
      APPEARANCE: "PMingLiU",
    },
    {
      fontFamily: "Raavi",
      APPEARANCE: "Raavi",
    },
    {
      fontFamily: "Rockwell",
      APPEARANCE: "Rockwell",
    },
    {
      fontFamily: "Rockwell Extra Bold",
      APPEARANCE: "Rockwell Extra Bold",
    },
    {
      fontFamily: "Rockwell Nova",
      APPEARANCE: "Rockwell Nova",
    },
    {
      fontFamily: "Rockwell Nova Cond",
      APPEARANCE: "Rockwell Nova Cond",
    },
    {
      fontFamily: "Rockwell Nova Extra Bold",
      APPEARANCE: "Rockwell Nova Extra Bold",
    },
    {
      fontFamily: "Rod",
      APPEARANCE: "Rod",
    },
    {
      fontFamily: "Sakkal Majalla",
      APPEARANCE: "Sakkal Majalla",
    },
    {
      fontFamily: "Sanskrit Text",
      APPEARANCE: "Sanskrit Text",
    },
    {
      fontFamily: "Segoe MDL2 Assets",
      APPEARANCE: "Segoe MDL2 Assets",
    },
    {
      fontFamily: "Segoe Print",
      APPEARANCE: "Segoe Print",
    },
    {
      fontFamily: "Segoe Script",
      APPEARANCE: "Segoe Script",
    },
    {
      fontFamily: "Segoe UI",
      APPEARANCE: "Segoe UI",
    },
    {
      fontFamily: "Segoe UI Emoji",
      APPEARANCE: "Segoe UI Emoji",
    },
    {
      fontFamily: "Segoe UI Historic",
      APPEARANCE: "Segoe UI Historic",
    },
    {
      fontFamily: "Segoe UI Symbol",
      APPEARANCE: "Segoe UI Symbol",
    },
    {
      fontFamily: "Shonar Bangla",
      APPEARANCE: "Shonar Bangla",
    },
    {
      fontFamily: "Shruti",
      APPEARANCE: "Shruti",
    },
    {
      fontFamily: "SimHei",
      APPEARANCE: "SimHei",
    },
    {
      fontFamily: "SimKai",
      APPEARANCE: "SimKai",
    },
    {
      fontFamily: "Simplified Arabic",
      APPEARANCE: "Simplified Arabic",
    },
    {
      fontFamily: "Simplified Chinese",
      APPEARANCE: "Simplified Chinese",
    },
    {
      fontFamily: "SimSun",
      APPEARANCE: "SimSun",
    },
    {
      fontFamily: "SimSun-ExtB",
      APPEARANCE: "SimSun-ExtB",
    },
    {
      fontFamily: "Sitka",
      APPEARANCE: "Sitka",
    },
    {
      fontFamily: "Snell Roundhan",
      APPEARANCE: "Snell Roundhan",
    },
    {
      fontFamily: "Stencil Std",
      APPEARANCE: "Stencil Std",
    },
    {
      fontFamily: "Sylfaen",
      APPEARANCE: "Sylfaen",
    },
    {
      fontFamily: "Symbol",
      APPEARANCE: "Symbol",
    },
    {
      fontFamily: "Tahoma",
      APPEARANCE: "Tahoma",
    },
    {
      fontFamily: "Thai",
      APPEARANCE: "Thai",
    },
    {
      fontFamily: "Times New Roman",
      APPEARANCE: "Times New Roman",
    },
    {
      fontFamily: "Traditional Arabic",
      APPEARANCE: "Traditional Arabic",
    },
    {
      fontFamily: "Traditional Chinese",
      APPEARANCE: "Traditional Chinese",
    },
    {
      fontFamily: "Trattatello",
      APPEARANCE: "Trattatello",
    },
    {
      fontFamily: "Trebuchet MS",
      APPEARANCE: "Trebuchet MS",
    },
    {
      fontFamily: "Tunga",
      APPEARANCE: "Tunga",
    },
    {
      fontFamily: "UD Digi Kyokasho",
      APPEARANCE: "UD Digi Kyokasho",
    },
    {
      fontFamily: "UD Digi KyoKasho NK-R",
      APPEARANCE: "UD Digi KyoKasho NK-R",
    },
    {
      fontFamily: "UD Digi KyoKasho NP-R",
      APPEARANCE: "UD Digi KyoKasho NP-R",
    },
    {
      fontFamily: "UD Digi KyoKasho N-R",
      APPEARANCE: "UD Digi KyoKasho N-R",
    },
    {
      fontFamily: "Urdu Typesetting",
      APPEARANCE: "Urdu Typesetting",
    },
    {
      fontFamily: "URW Chancery",
      APPEARANCE: "URW Chancery",
    },
    {
      fontFamily: "Utsaah",
      APPEARANCE: "Utsaah",
    },
    {
      fontFamily: "Vani",
      APPEARANCE: "Vani",
    },
    {
      fontFamily: "Verdana",
      APPEARANCE: "Verdana",
    },
    {
      fontFamily: "Verdana Pro",
      APPEARANCE: "Verdana Pro",
    },
    {
      fontFamily: "Vijaya",
      APPEARANCE: "Vijaya",
    },
    {
      fontFamily: "Vrinda",
      APPEARANCE: "Vrinda",
    },
    {
      fontFamily: "Webdings",
      APPEARANCE: "Webdings",
    },
    {
      fontFamily: "Westminster",
      APPEARANCE: "Westminster",
    },
    {
      fontFamily: "Wingdings",
      APPEARANCE: "Wingdings",
    },
    {
      fontFamily: "Yu Gothic",
      APPEARANCE: "Yu Gothic",
    },
    {
      fontFamily: "Yu Gothic UI",
      APPEARANCE: "Yu Gothic UI",
    },
    {
      fontFamily: "Yu Mincho",
      APPEARANCE: "Yu Mincho",
    },
    {
      fontFamily: "Zapf Chancery",
      APPEARANCE: "Zapf Chancery",
    },
  ];
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "400px",
    minHeight: "0",
    maxHeight: "auto",
    width: "auto",
    minWidth: "0",
    translate: "yes",
    enableToolbar: true,
    showToolbar: true,
    placeholder: "Enter text here...",
    defaultParagraphSeparator: "",
    defaultFontName: "",
    defaultFontSize: "",
    fonts: this.fontFamily.map((font) => {
      return {
        class: font.APPEARANCE.toLowerCase().replace(/ /g, "-"),
        name: font.fontFamily,
      };
    }),
    // [
    //   {class: 'arial', name: 'Arial'},
    //   {class: 'times-new-roman', name: 'Times New Roman'},
    //   {class: 'calibri', name: 'Calibri'},
    //   {class: 'comic-sans-ms', name: 'Comic Sans MS'},
    //   {class: 'courier-new', name: 'Courier New'}
    // ]
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    uploadUrl: "v1/image",
    sanitize: true,
    toolbarPosition: "top",
  };
  clone(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
  isEgaleObject(obj1: Object, obj2: Object) {
    var str1 = JSON.stringify(obj1);
    var str2 = JSON.stringify(obj2);
    return str1 == str2;
  }
  rechercheTable(url: string) {
    return this.http.get<any>(this.api + url);
  }
  enregisterTable(ds) {
    return this.http.post<any>(this.api + "ds/post", ds);
  }
  postDs(data) {
    return this.http.post(this.api + "ds/post", data);
  }
  delete(data, codeform) {
    return this.http.delete(
      this.api + "/ds/delete/?data=" + data + "&formcode=" + codeform
    );
  }
  distinct(ds, attribut) {
    return ds
      .map((item) => eval("item." + attribut))
      .filter((value, index, self) => self.indexOf(value) === index);
  }

  isNotEmpty(text): boolean {
    if (text == null || text == undefined || text.toString() == "")
      return false;
    else return true;
  }
  dialogSuccess(msg: string, status: boolean) {
    let config = new MatSnackBarConfig();
    config.horizontalPosition = this.horizontalPosition;
    config.duration = true ? 6000 : 0;
    if (!status) config.panelClass = "custom-class";
    else config.panelClass = "custom-classGreen";
    this.snackBar.open(msg, true ? "" : undefined, config);
  }
  editFiles(node) {
    this.rechercheTable(this.urlFiles + "&val=" + node.a_attr.myId).subscribe(
      (file) => {
        file.Files[0].File_Text = node.text;
        file.Files[0].File_Lien = node.a_attr.File_Lien;
        this.enregisterTable(file).subscribe((data) => {
          this.disabled = false;
          this.dialogSuccess("L'opération est réussie", true);
        });
      }
    );
  }
  async addFiles(
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    var id;
    var doc = this.clone(this.dsFile);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;

      id = await this.enregisterTable(doc).toPromise();
      this.dialogSuccess("Document enregisté", true);
      this.disabled = false;
    }
    return id;
  }
  generateTreeData(docCollBrut) {
    var parentTree = [];
    docCollBrut.forEach((doc) => {
      var categorie_CodeP = doc.categorie_CodeP;
      if (doc.categorie_CodeP == null || doc.categorie_CodeP == "")
        categorie_CodeP = "#";
      var ecArtCarMod_Label = "";
      if (doc.ecArtCarMod_Label != null && doc.ecArtCarMod_Label != "")
        ecArtCarMod_Label = this.clone(
          " <b>(Modèle: " + doc.ecArtCarMod_Label + ")</b>"
        );
      parentTree.push({
        id: doc.categorie_Code,
        parent: categorie_CodeP,
        text: doc.categorie_Text + this.clone(ecArtCarMod_Label),
        a_attr: { myId: doc.categorie_Code, groupe: "", File_Lien: "" },
        icon: "jstree-folder",
      });
    });
    parentTree = this.enleverNodeErroner(parentTree);

    return parentTree;
  }
  enleverNodeErroner(parentTree) {
    //pour eliminer les neux de id == vide;
    parentTree = parentTree.filter((node) => {
      return (
        node.id != null &&
        node.id != "" &&
        node.id != undefined &&
        node.id != " "
      );
    });
    //pour eliminer les neux qui ne contient pas un parent, sauf les neux de parent = à #()
    var test = false;
    //en cas ou parentTree n'a pas de neux qui ne contient pas un parent => en vas boukler pour l'infine
    var compt = 9000;
    do {
      compt--;
      test = true;
      parentTree.forEach((element) => {
        if (
          parentTree.find((n) => {
            return n.id == element.parent;
          }) == undefined &&
          element.parent != "#"
        ) {
          test = false;
          parentTree = parentTree.filter((f) => {
            return f.id != element.id;
          });
        }
      });
      if (compt < 0) test = false;
    } while (test);
    return parentTree;
  }
  redimentionnerImage(image, width, height, netteter) {
    return image;

    if (image.currentSrc.indexOf("data:image/gif;") > -1) return image.src;
    var maxWidth = width,
      maxHeight = height,
      imageWidth = image.width,
      imageHeight = image.height;
    if (imageWidth > imageHeight) {
      imageHeight *= maxWidth / imageWidth;
      imageWidth = maxWidth;
    } else {
      imageWidth *= maxHeight / imageHeight;
      imageHeight = maxHeight;
    }
    var mime_type;
    if (image.currentSrc.indexOf("data:image/gif;") > -1)
      mime_type = "image/gif";
    else mime_type = "image/jpeg";
    var canvas = document.createElement("canvas");
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    image.width = imageWidth;
    image.height = imageHeight;
    var ctx1 = canvas.getContext("2d");
    ctx1.drawImage(image, 0, 0, imageWidth, imageHeight);
    var newImageData = canvas.toDataURL(mime_type, netteter / 100);
    var result_image_obj = new Image();
    result_image_obj.src = newImageData;
    if (image.src.length < result_image_obj.src.length) return image.src;
    else return result_image_obj.src;
  }
  supprimer(id, ds) {
    // if(this.userConnecter == "admin" || true)
    // {
    if (confirm("Vouler vous supprimer cette elément")) {
      /* si on clique sur ok */ return this.http.delete(
        this.api + "ds/delete?data=" + id + "&codeform=" + ds + "&control=1"
      );
    } else return null;
    // }
    // else
    // this.dialogSuccess("vous n'avez pas le droit de suppression",false)
  }
  supprimerSanMsgConfirm(id, ds) {
    return this.http.delete(
      this.api + "ds/delete?data=" + id + "&codeform=" + ds + "&control=1"
    );
  }
  async modifierLanguage(Lg_Id, Lg_Libelle, setDisabled?) {
    try {
      var data = await this.rechercheTable(
        "ds/formdata?code=Lg&val=" + Lg_Id
      ).toPromise();

      data.Lg[0].Lg_Libelle = Lg_Libelle;
      data.Lg[0].Lg_Source = "WEB";
      await this.enregisterTable(data)
        .toPromise()
        .catch(() => {
          this.dialogSuccess("Non enregistrer", false);
        });
      this.dialogSuccess("Enregistrer", true);
      if (setDisabled) this.disabled = false;
    } catch {}

    // },()=>
    // {
    //   this.dialogSuccess("Non enregistrer",false);this.disabled = false
    // })
    // },()=>
    // {
    //   this.dialogSuccess("Non enregistrer",false);this.disabled = false
    // });
  }
  getDsLanguage() {
    try {
      this.rechercheTable("ds/formdata?code=Lg").subscribe((data) => {
        this.dsLanguage = data;
      });
    } catch {}
  }
  getDsFile() {
    this.rechercheTable("ds/ajout?dstables=files").subscribe((doc) => {
      this.dsFile = doc;
    });
  }
  enregistrerLanguage(Lg_Code, Lg_Langue, Lg_Libelle) {
    try {
      this.dsLanguage.Lg[0].Lg_Code = Lg_Code;
      this.dsLanguage.Lg[0].Lg_Langue = Lg_Langue;
      this.dsLanguage.Lg[0].Lg_Libelle = Lg_Libelle;
      this.dsLanguage.Lg[0].Lg_Source = "WEB";
      this.enregisterTable(this.dsLanguage).subscribe(
        (data) => {
          this.dialogSuccess("Enregistrer", true);
          this.disabled = false;
        },
        () => {
          this.dialogSuccess("Non enregistrer", false);
          this.disabled = false;
        }
      );
    } catch {}
  }
  sort(liste, attribut) {
    liste.sort((a, b) => {
      const bandA = a[attribut].toString().toUpperCase();
      const bandB = b[attribut].toString().toUpperCase();
      let comparison = 0;
      if (bandA > bandB) comparison = 1;
      else if (bandA < bandB) comparison = -1;
      return comparison;
    });
    return liste;
  }

  uploadFile2(blob: Blob, fileName: string) {
    const formData = new FormData();
    formData.append(
      "File",
      this.renameFile(
        blob,
        fileName.toString().slice(0, 10) +
          "." +
          fileName.toString().split(".")[1]
      ),
      fileName.toString().slice(0, 10) + "." + fileName.toString().split(".")[1]
    );
    return this.http.post(this.api + "files", formData);
  }
  uploadFile(blob, fileName: string) {
    const formData = new FormData();
    formData.append("File", blob, fileName);
    return this.http.post(this.api + "files", formData, {
      reportProgress: true,
      observe: "events",
    });
  }
  renameFile(originalFile, newName) {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  }
}
